import React from 'react'

// ADAS Report header icons, traced from the Figma handoff (18796:156095) rather
// than substituted with Font Awesome glyphs (the previous FaAngleDoubleDown /
// FaAngleDoubleUp were not the design's artwork).
//
// Inlined as components instead of imported .svg files because the
// expand/collapse pair changes colour with its active state, which an <img src>
// cannot do — `stroke="currentColor"` lets CSS drive it.
//
// The admin portal carries its own copy of these in AdasReportDetail.js. That is
// deliberate: the two portals are separate builds with no shared module between
// them, so the small duplication is the correct trade (see MTRX/CLAUDE.md).

export const ShieldIcon = () => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' aria-hidden='true' focusable='false'>
    <path
      d='M12.5 8.125C12.5 11.25 10.3125 12.8125 7.7125 13.7188C7.57635 13.7649 7.42846 13.7627 7.29375 13.7125C4.6875 12.8125 2.5 11.25 2.5 8.125V3.75C2.5 3.58424 2.56585 3.42527 2.68306 3.30806C2.80027 3.19085 2.95924 3.125 3.125 3.125C4.375 3.125 5.9375 2.375 7.025 1.425C7.15741 1.31187 7.32585 1.24972 7.5 1.24972C7.67415 1.24972 7.84259 1.31187 7.975 1.425C9.06875 2.38125 10.625 3.125 11.875 3.125C12.0408 3.125 12.1997 3.19085 12.3169 3.30806C12.4342 3.42527 12.5 3.58424 12.5 3.75V8.125Z'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

// Carets pointing apart — "expand all".
export const ExpandAllIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' aria-hidden='true' focusable='false'>
    <path d='M5.25 11.25L9 15L12.75 11.25' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.25 6.75L9 3L12.75 6.75' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

// Carets pointing together — "collapse all".
export const CollapseAllIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' aria-hidden='true' focusable='false'>
    <path d='M5.25 15L9 11.25L12.75 15' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M5.25 3L9 6.75L12.75 3' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
